import React, {FormEvent, memo, ReactNode, useCallback, useEffect, useRef, useState} from 'react';
import {useDebounce} from '../../../hooks/debounce';
import {RangeRawComponent} from '../RangeRawComponent';
import {ColumnProps} from '../../Column';

type Props = {
    name: string;
    value: number;
    onChange: (value: number) => void;
    activeImage: string;
    passiveImage: string;
    columnProps?: Partial<ColumnProps>;
    children?: ReactNode;
};

export const RangeComponent = memo(function RangeComponent(props: Props) {
    const {name,columnProps , value: valueProp, onChange: onChangeProp, children, activeImage, passiveImage} = props;

    const [tempValue, setTempValue] = useState(0);
    const [value, setValue] = useState(valueProp);
    const timeoutRef = useRef<number>();

    const onChangeCallback = useDebounce(onChangeProp, 200);

    const click = useCallback(() => {
        let newValue;
        if (value > 0) {
            setTempValue(value);
            newValue = 0;
        } else if (tempValue > 0) {
            newValue = tempValue;
        } else {
            newValue = 100;
        }

        setValue(newValue);
        onChangeCallback(newValue);
    }, [tempValue, value, onChangeCallback]);

    const onChange = useCallback((e: FormEvent<HTMLInputElement>) => {
        // @ts-ignore
        const newValue = e.target.valueAsNumber;
        if (newValue !== value) {
            setValue(newValue);
            onChangeCallback(newValue);
        }
    }, [onChangeCallback, value]);

    useEffect(() => {
        setValue(valueProp);
    }, [valueProp]);

    useEffect(() => {
        timeoutRef.current = setTimeout(() => {
            if (value !== valueProp) {
                setValue(valueProp);
            }
        }, 2000);

        return () => clearTimeout(timeoutRef.current);
    }, [value, valueProp]);

    return (
        <RangeRawComponent
            columnProps={columnProps}
            name={name}
            click={click}
            value={value}
            onChange={onChange}
            activeImage={activeImage}
            passiveImage={passiveImage}>
            {children}
        </RangeRawComponent>
    );
});
